(function () {
  var formStyles =
    ':host {' +
    '--container-background-color: transparent !important;' +
    '--container-max-w: 946px !important;' +
    '--inline-container-max-width: 946px !important;' +
    '--inline-form-alignment: center !important;' +
    '--forms-base-font-size: 16px !important;' +
    '--forms-heading-font-size: 36px !important;' +
    '--forms-body-font: normal 700 16px "Avenir Next", Helvetica, Arial, sans-serif !important;' +
    '--forms-heading-font: normal 400 36px "MADE Mountain", "Rockwell Nova", Georgia, serif !important;' +
    '--forms-accent-color: #dc8c27 !important;' +
    '--forms-focus-outline-color: #dc8c27 !important;' +
    '--form-field-border: none !important;' +
    '--form-field-border-focused: 0 0 0 2px #dc8c27 !important;' +
    '--form-field-border-radius: 8px !important;' +
    '--button-background-color: #dc8c27 !important;' +
    '--button-text-color: #eeede4 !important;' +
    '--button-border-radius: 12px !important;' +
    '--button-padding: 15px 20px !important;' +
    '--form-background-color: transparent !important;' +
    '}' +
    'input { box-sizing: border-box !important; }' +
    '[class*="_container_"], [class*="_formContainer_"], [class*="_inline_"] {' +
    'background: transparent !important; box-shadow: none !important; max-width: 946px !important; padding: 0 !important; width: 100% !important;' +
    '}' +
    '[class*="_grid_"] { display: block !important; }' +
    '[class*="_gridItem_"][class*="_imageLoading_"] { display: none !important; }' +
    '[class*="_gridItemContent_"] { display: block !important; padding: 0 !important; }' +
    '[class*="_formHeader_"] { margin: 0 0 30px !important; text-align: center !important; }' +
    '[class*="_textHeading_"] {' +
    'color: #2b241f !important; font-family: "MADE Mountain", "Rockwell Nova", Georgia, serif !important;' +
    'font-size: clamp(32px, 4vw, 36px) !important; font-weight: 400 !important; line-height: 1.02 !important;' +
    'margin: 0 !important; text-transform: uppercase !important;' +
    '}' +
    'form[data-testid="form"] {' +
    'align-items: start !important; display: grid !important; gap: 24px 30px !important;' +
    'grid-template-columns: repeat(2, minmax(0, 458px)) !important; justify-content: center !important;' +
    'margin: 30px auto 0 !important; max-width: 946px !important; padding: 0 !important; width: 100% !important;' +
    '}' +
    'form[data-testid="form"] > div:has(shop-lead-capture) { display: none !important; }' +
    '[class*="_formFieldContainer_"]:not([class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"]),' +
    '[class*="_selectContainer_"]:not([class*="_formPhoneInputContainer_"] [class*="_selectContainer_"]) {' +
    'margin: 0 !important; padding-top: 28px !important; position: relative !important; width: 100% !important;' +
    '}' +
    '[class*="_formInputFieldLabel_"], [class*="_selectContainer_"] [class*="_label_"] {' +
    'color: #2b241f !important; font-family: "MADE Mountain", "Rockwell Nova", Georgia, serif !important;' +
    'font-size: 18px !important; font-weight: 400 !important; left: 0 !important; line-height: 1.25 !important;' +
    'opacity: 1 !important; position: absolute !important; top: 0 !important; transform: none !important;' +
    '}' +
    '[class*="_formInputField_"], [class*="_selectToggle_"], [class*="_formPhoneInputField_"] {' +
    'background: rgba(170, 157, 135, 0.25) !important; border: 0 !important; border-radius: 8px !important;' +
    'box-shadow: none !important; color: #2b241f !important; font-family: "Avenir Next", Helvetica, Arial, sans-serif !important;' +
    'font-size: 16px !important; min-height: 47px !important; padding: 10px 14px !important; width: 100% !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] {' +
    'display: grid !important; grid-template-columns: auto 1fr !important; grid-template-areas: none !important;' +
    'align-items: stretch !important; column-gap: 8px !important; row-gap: 0 !important; margin: 0 !important;' +
    'padding-top: 0 !important; position: relative !important; width: 100% !important; height: auto !important; overflow: visible !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] > [class*="_formFieldContainer_"] {' +
    'display: block !important; margin: 0 !important; padding-top: 28px !important; position: relative !important; width: auto !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"],' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"][class*="_inputFilled_"] {' +
    'grid-area: unset !important; order: unset !important; color: #2b241f !important;' +
    'font-family: "MADE Mountain", "Rockwell Nova", Georgia, serif !important; font-size: 18px !important;' +
    'font-weight: 400 !important; left: 0 !important; line-height: 1.25 !important; opacity: 1 !important;' +
    'position: absolute !important; top: 0 !important; transform: none !important; padding: 0 !important; margin: 0 !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] .phone-country-selector {' +
    'align-self: stretch !important; width: auto !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] .phone-country-selector [class*="_selectContainer_"] {' +
    'display: block !important; height: 100% !important; margin: 0 !important; padding-top: 28px !important;' +
    'position: relative !important; width: auto !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] .phone-country-selector [class*="_selectToggle_"] {' +
    'align-items: center !important; display: flex !important; gap: 8px !important; height: 47px !important;' +
    'justify-content: center !important; min-height: 47px !important; min-width: 72px !important; padding: 0 12px !important;' +
    'width: auto !important;' +
    '}' +
    'form[data-testid="form"] [class*="_formPhoneInputContainer_"] [class*="_formPhoneInputField_"] {' +
    'grid-area: unset !important; width: 100% !important; min-width: 0 !important;' +
    '}' +
    '[class*="_dropdownContainer_"], [class*="_dropdownContainer_"] div, .phone-country-selector [class*="_selectToggle_"] {' +
    'background-color: rgba(170, 157, 135, 0.25) !important; border: 0 !important; border-radius: 8px !important; min-height: 47px !important;' +
    '}' +
    '[class*="_checkboxFieldSet_"] { border: 0 !important; grid-column: 1 / -1 !important; margin: 0 !important; padding: 0 !important; }' +
    '[class*="_checkboxLegend_"] { display: none !important; }' +
    '[class*="_verticalLayout_"] { display: grid !important; gap: 10px !important; }' +
    'form[data-testid="form"] [class*="_radioField_"]:not([class*="_radioFieldSet_"]),' +
    'form[data-testid="form"] [class*="_checkboxField_"]:not([class*="_checkboxFieldSet_"]),' +
    '[class*="_consentCheckboxContainer_"] [class*="_checkboxField_"] {' +
    'align-items: flex-start !important; background: transparent !important; background-color: transparent !important;' +
    'border: 0 !important; border-radius: 0 !important; box-shadow: none !important; column-gap: 10px !important;' +
    'display: flex !important; grid-template-columns: none !important; min-height: 0 !important; padding: 0 !important;' +
    'width: 100% !important; margin: 0 !important;' +
    '}' +
    '[class*="_consentCheckboxContainer_"] { background: transparent !important; padding: 0 !important; }' +
    '[class*="_checkboxWrapper_"], [class*="_checkboxInput_"] {' +
    'flex: 0 0 24px !important; height: 24px !important; margin: 0 !important; width: 24px !important;' +
    '}' +
    'input[type="checkbox"], [class*="_checkboxInput_"] {' +
    'appearance: none !important; -webkit-appearance: none !important; background-color: #eeede4 !important;' +
    'border: 1.5px solid #2b241f !important; border-radius: 4px !important; accent-color: #dc8c27 !important;' +
    '}' +
    'input[type="checkbox"]:checked, [class*="_checkboxInput_"]:checked {' +
    'background-color: #dc8c27 !important; border-color: #dc8c27 !important;' +
    '}' +
    '[class*="_checkboxField_"] [class*="_textBody_"] {' +
    'color: #2b241f !important; font-family: "MADE Mountain", "Rockwell Nova", Georgia, serif !important;' +
    'font-size: 18px !important; line-height: 1.25 !important; text-align: left !important;' +
    '}' +
    '[class*="_checkboxField_"] a, [class*="_formDisclaimer_"] a { color: #dc8c27 !important; }' +
    '[data-testid="btn-form-submit"] {' +
    'align-items: center !important; background: #dc8c27 !important; border: 0 !important; border-radius: 12px !important;' +
    'color: #eeede4 !important; display: flex !important; font-family: "Avenir Next", Helvetica, Arial, sans-serif !important;' +
    'font-size: 13px !important; font-weight: 900 !important; grid-column: 1 / -1 !important; justify-content: center !important;' +
    'justify-self: center !important; letter-spacing: 0.05em !important; line-height: 1 !important; min-height: 48px !important;' +
    'padding: 0 !important; text-transform: uppercase !important; width: min(515px, 100%) !important;' +
    '}' +
    '[class*="_formDisclaimer_"] {' +
    'color: rgba(43, 36, 31, 0.55) !important; font-family: "Avenir Next Condensed", "Oswald", sans-serif !important;' +
    'font-size: 16px !important; font-weight: 700 !important; grid-column: 1 / -1 !important; margin-top: 30px !important;' +
    'max-width: 946px !important; text-align: center !important;' +
    '}' +
    '[class*="_formDisclaimer_"] p { margin-top: 30px !important; line-height: 1.25 !important; }' +
    'form p::after, form input+label::after { content: " (Required)" !important; opacity: 0.5 !important; }' +
    '@media only screen and (max-width: 700px) { form[data-testid="form"] { grid-template-columns: 1fr !important; } }';

  function purgeContactFormStyles() {
    if (!window.formStyles || !window.formStyles.delete) return;
    window.formStyles.delete('cowbell-contact-form');
  }

  function styleEmbed(embed) {
    if (!embed || !embed.shadowRoot) return false;
    var shadow = embed.shadowRoot;

    purgeContactFormStyles();

    shadow.querySelectorAll('style').forEach(function (node) {
      if (node.getAttribute('data-contest-landing-forms-style')) return;
      var text = node.textContent || '';
      if (
        node.id === 'cowbell-forms-overrides' ||
        text.indexOf('phone-label') !== -1 ||
        text.indexOf('cowbell-contact-form') !== -1 ||
        (text.indexOf('_checkboxField_') !== -1 && text.indexOf('rgba(170, 157, 135, 0.25)') !== -1)
      ) {
        node.remove();
      }
    });

    var contactPatch = shadow.getElementById('cowbell-forms-overrides');
    if (contactPatch) contactPatch.remove();

    var existing = shadow.querySelector('[data-contest-landing-forms-style]');
    if (existing) existing.remove();

    var style = document.createElement('style');
    style.setAttribute('data-contest-landing-forms-style', '');
    style.textContent = formStyles;
    shadow.appendChild(style);
    return true;
  }

  function styleContestForms() {
    purgeContactFormStyles();
    document.querySelectorAll('.contest-landing__entry--app shopify-forms-embed, .contest-landing shopify-forms-embed').forEach(styleEmbed);
  }

  purgeContactFormStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleContestForms);
  } else {
    styleContestForms();
  }

  var pollCount = 0;
  var pollTimer = setInterval(function () {
    styleContestForms();
    pollCount += 1;
    if (pollCount >= 80) clearInterval(pollTimer);
  }, 250);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(styleContestForms).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
